import { Link } from "react-router";
import CustomBreadcrumb from "../../components/CustomBreadcrumb";
import { Table, type TableProps } from "antd";
import { useEffect, useState } from "react";
import { useStore } from "zustand";
import { useDashboardName } from "../../store/headerName";
import ConfirmModal from "../../components/modal/ConfirmModal";
import ButtonIcon from "../../components/ButtonIcon";
import StatusVisit from "../../components/StatusVisit";
import BaseCard from "../../components/card/BaseCard";
import { Icon } from "@iconify/react";
import BaseTable from "../../components/BaseTable";
import { $api, type components } from "../../helper";
import { GetFullMediaPath } from "../../helper/method";
import { statusMock, tokenMock } from "../../helper/mock";
import ButtonLinkIcon from "../../components/ButtonLinkIcon";
import { useNotify } from "../../helper/notify";
import FilterSearch from "../../components/filter/FilterSearch";
import ButtonIconSvg from "../../components/ButtonIconSvg";
import Trash from "../../components/svg/Trash";
import ButtonLinkIconSvg from "../../components/ButtonLinkIconSvg";
import PenSquare from "../../components/svg/PenSquare";

export default function FaqCategory() {
  const [isOpen, setIsOpen] = useState(false);
  const notify = useNotify();
  const [id, setId] = useState({
    u_id: "",
    title: "",
  });
  const { data, isLoading, refetch } = $api.useQuery(
    "get",
    "/site-api/v1/faq/category/",
  );
  const { mutate, isPending } = $api.useMutation(
    "delete",
    "/site-api/v1/faq/category/",
    {
      onSuccess: (data) => {
        notify.success(data.message);
        setIsOpen(false);
        setId({ u_id: "", title: "" });
        refetch();
      },
    },
  );
  const { setDashboardName } = useStore(useDashboardName);
  useEffect(() => {
    setDashboardName("سوالات متداول");
  }, []);

  const columns: TableProps<
    components["schemas"]["SiteFaqCategoryItem"]
  >["columns"] = [
    {
      title: "#",
      dataIndex: "key",
      key: "key",
      render: (_, record, index) => <span>{index + 1}</span>,
    },
    {
      title: "تصویر دسته بندی",
      dataIndex: "desktop_image",
      key: "desktop_image",
      render: (_, record) => (
        <div className="aspect-square w-16 rounded-lg overflow-hidden">
          <img
            src={GetFullMediaPath(record.desktop_image)}
            alt=""
            className="w-full h-full object-cover"
          />
        </div>
      ),
    },
    {
      title: "عنوان دسته بندی",
      dataIndex: "title",
      key: "title",
      filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
        clearFilters,
      }) => (
        <FilterSearch
          clearFilters={clearFilters}
          confirm={confirm}
          selectedKeys={selectedKeys}
          setSelectedKeys={setSelectedKeys}
        />
      ),
      onFilter: (value, record) =>
        record?.title
          ?.toLowerCase()
          ?.includes(value.toString().toLocaleLowerCase()),
      filterIcon: () => (
        <Icon className="text-xl" icon={"solar:magnifer-linear"} />
      ),
    },
    {
      title: "نمایش در سایت",
      key: "status",
      dataIndex: "status",
      filters: statusMock,
      onFilter: (value, record) =>
        record.status.toString().indexOf(value as string) === 0,
      render: (_, record) => <StatusVisit status={record.status} />,
    },
    {
      title: "عملیات",
      key: "action",
      render: (_, record) => (
        <div className="flex">
          {/* <ButtonLinkIcon
            to={{
              pathname: "/add-faq-category",
              search: "?u_id=" + record.u_id,
            }}
            icon="solar:pen-new-square-linear"
            className="text-primary-500!"
          /> */}
          <ButtonLinkIconSvg
            icon={<PenSquare />}
            to={{
              pathname: "/add-faq-category",
              search: "?u_id=" + record.u_id,
            }}
            className="text-primary-500!"
          />
          {/* <ButtonIcon
            icon="solar:trash-bin-trash-linear"
            className="text-error-500!"
            onClick={() => {
              setIsOpen(true);
              setId({ u_id: record.u_id, title: record.title });
            }}
          /> */}
          <ButtonIconSvg
            icon={<Trash />}
            className="text-error-500!"
            onClick={() => {
              setIsOpen(true);
              setId({ u_id: record.u_id, title: record.title });
            }}
          />
        </div>
      ),
    },
  ];

  return (
    <div className="flex flex-col gap-6">
      {/* modal */}
      <ConfirmModal
        pending={isPending}
        title={`حذف دسته بندی ${id.title} ؟`}
        description="حذف این دسته‌بندی باعث عدم نمایش آن در بخش‌های مرتبط می‌شود."
        action={() =>
          mutate({
            params: { query: { category_u_id: id.u_id } },
            headers: {
              "Content-Type": "application/json",
              Authorization: tokenMock,
              lang: "fa",
            },
          })
        }
        open={isOpen}
        onClose={() => {
          setIsOpen(false);
          setId({ u_id: "", title: "" });
        }}
      />
      <div className="w-full flex justify-between sm:flex-row sm:gap-0 gap-4 flex-col sm:items-center items-start">
        <CustomBreadcrumb
          first="سوالات متداول"
          second="لیست دسته بندی سوالات متداول"
        />
        <Link to={"/add-faq-category"} className="button-style">
          ایجاد دسته بندی
        </Link>
      </div>
      <BaseCard props={{ className: "flex-1 flex-col flex gap-6 w-full!" }}>
        <BaseTable props={{ className: "w-full! grid! grid-cols-1!" }}>
          <Table<components["schemas"]["SiteFaqCategoryItem"]>
            className="col-span-1!"
            scroll={{ x: "max-content" }}
            columns={columns}
            dataSource={data?.data}
            loading={isLoading}
          />
        </BaseTable>
      </BaseCard>
    </div>
  );
}
